module.exports = __webpack_public_path__ + "img/vector-tanks-extreme-screenshot.d7641773.jpg";